import { Denomination } from "@/model/data/Denomination";
import { ApiGenericResponse } from "../ApiGenericResponse";
import { AxiosResponse } from "axios";

export class GetAllDenominationsResData extends ApiGenericResponse {
    allDenominations: Array<Denomination>;

    constructor(response: AxiosResponse) {
        super(response);

        if (response.data && response.data.Payload) {
            this.parse(response.data.Payload);
        }
    }

    public parse(obj: any) {
        if (obj.AllDenominations) {
            this.allDenominations = new Array<Denomination>();
            obj.AllDenominations.forEach((denomination) => {
                let d = new Denomination();
                d.parse(denomination);
                this.allDenominations.push(d);
            });
        }
    }
}
